import { useEffect, useState } from "react";
import Sidebar from "./Sidebar";
import Header from "./Header";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useDispatch } from "react-redux";
import { updateLastLogin } from "../redux/actions/userActions";
import NotificationAlertModal from "../components/NotificationAlertModal";
import useNotificationCheck from "../hooks/useNotificationCheck";
// import axios from "axios";

const DefaultLayout = (props) => {
  const dispatch = useDispatch();
  const [sidebarOpen, setSidebarOpen] = useState(false);

  // Use the notification check hook
  const { showModal, unreadCount, closeModal } = useNotificationCheck();


  // Update last login time when component mounts
  useEffect(() => {
    dispatch(updateLastLogin());
  }, [dispatch]);

  return (
    <div className="bg-gray min-h-screen">
      {/* Notification Alert Modal */}
      <NotificationAlertModal
        isOpen={showModal}
        onClose={closeModal}
        unreadCount={unreadCount}
      />

      {/* <!-- ===== Page Wrapper Start ===== --> */}
      <div className="flex h-screen overflow-hidden">
        {/* <!-- ===== Sidebar Start ===== --> */}
        <Sidebar
          sidebarOpen={sidebarOpen}
          setSidebarOpen={() => setSidebarOpen(!sidebarOpen)}
        />
        {/* <!-- ===== Sidebar End ===== --> */}

        {/* <!-- ===== Content Area Start ===== --> */}
        <div className="relative flex flex-1 flex-col overflow-y-auto overflow-x-hidden bg-gray">
          {/* <!-- ===== Header Start ===== --> */}
          <Header
            sidebarOpen={sidebarOpen}
            setSidebarOpen={() => setSidebarOpen(!sidebarOpen)}
          />
          <ToastContainer
            position="top-right"
            autoClose={3000}
            hideProgressBar={false}
            newestOnTop={false}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
            theme="light"
          />
          {/* <!-- ===== Header End ===== --> */}

          {/* <!-- ===== Main Content Start ===== --> */}
          <main className="p-4 md:p-6 2xl:p-10">
            <div className="mx-auto max-w-screen-2xl">
              {props.children}
            </div>
          </main>
          {/* <!-- ===== Main Content End ===== --> */}
        </div>
        {/* <!-- ===== Content Area End ===== --> */}
      </div>
      {/* <!-- ===== Page Wrapper End ===== --> */}
    </div>
  );
};

export default DefaultLayout;
